export const SPECIALIST_JOURNEY_IDS = Object.freeze([
  'kch-critical-care-visitor',
]);

const COMPLETION = Object.freeze({
  compact: true,
  label: 'Journey summary',
  title: "You've reached the end of this guide",
  description: 'You do not need to open everything. Use the parts that are helpful to you and return whenever you need them.',
});

const QUALITY_BY_JOURNEY_ID = Object.freeze({
  'kch-critical-care-visitor': {
    stages: [
      {
        id: 'arriving-and-getting-oriented',
        title: 'Arriving and getting oriented',
        description: 'Understand the critical care environment, visiting arrangements and who is looking after your relative.',
        phraseKeys: ['intensiveCareUnit', 'criticalCare', 'monitoring', 'ventilator', 'sedation', 'familyVisiting'],
        linkIds: ['visiting', 'environment'],
        questionIndexes: [0, 1, 3],
      },
      {
        id: 'updates-and-support',
        title: 'Updates and support',
        description: 'Know how the family can receive updates, what may be helpful during visits and where to find support.',
        phraseKeys: ['intubation', 'arterialLine', 'centralLine', 'vasopressors', 'organSupport'],
        linkIds: ['communication', 'support'],
        questionIndexes: [2, 4, 5],
      },
      {
        id: 'what-happens-next',
        title: 'What happens next',
        description: 'Understand language you may hear as care changes and what may happen when someone is ready to leave critical care.',
        phraseKeys: ['tracheostomy', 'weaning', 'stepDown', 'stable', 'criticalCareOutreach', 'recoveryAfterIcu'],
        linkIds: [],
        questionIndexes: [6],
      },
    ],
  },
});

export function applySpecialistJourneyQuality(journey) {
  if (!journey) return journey;
  const quality = QUALITY_BY_JOURNEY_ID[journey.id];
  if (!quality) return journey;

  return {
    ...journey,
    completion: journey.completion || COMPLETION,
    stages: quality.stages,
  };
}
